// extracted by mini-css-extract-plugin
export default {"HeroCardAccordionList":"xfHwFmt4iS"};